export default __webpack_public_path__ + "0265f62f99be181aa52d972677bdf5dc.woff2";